import type { Locale } from "../../types/locale";

type FolderLocale = Pick<Locale, "isDefault" | "storyblokFolder">;

/** `true` or the string "true" (LOCALES env JSON carries strings). */
export const isTruthy = (value: unknown): boolean => {
	if (typeof value === "boolean") return value;
	if (typeof value === "string") return value.toLowerCase() === "true";
	return false;
};

/** A folder name, or `null` when unset or blank. */
export const trimFolder = (value: unknown): string | null => {
	if (typeof value !== "string") return null;
	const t = value.trim();
	return t === "" ? null : t;
};

/** The default site's folder: the default locale's own, else the deploy's. */
export const defaultSiteFolder = (
	locales: FolderLocale[],
	envFolder: unknown
): string | null =>
	trimFolder(locales.find((l) => isTruthy(l.isDefault))?.storyblokFolder) ??
	trimFolder(envFolder);

/** A locale's folder: its own, else the default site's. */
export const localeSiteFolder = (
	locale: Partial<FolderLocale> | undefined,
	locales: FolderLocale[],
	envFolder: unknown
): string | null =>
	trimFolder(locale?.storyblokFolder) ?? defaultSiteFolder(locales, envFolder);
